<template>
  <div class="events__entity-options">
    <p class="overline mb-4 grey--text text--darken-2">
      {{ entityTranslation }}
    </p>
    <v-checkbox
      v-if="shouldDisplayEvent('created')"
      class="mt-n4 mb-0"
      data-testid="checkboxList-checkbox-created"
      :disabled="isLoading"
      :label="$t('organization_settings.webhooks_created_event')"
      :value="`${entityName}Created`"
      v-model="selectedEvents"
      @change="handleChange"
    />
    <v-checkbox
      v-if="shouldDisplayEvent('updated')"
      class="mt-n4 mb-0"
      data-testid="checkboxList-checkbox-updated"
      :disabled="isLoading"
      :label="$t('organization_settings.webhooks_updated_event')"
      :value="`${entityName}Updated`"
      v-model="selectedEvents"
      @change="handleChange"
    />
    <v-checkbox
      v-if="shouldDisplayEvent('deleted')"
      class="mt-n4 mb-0"
      data-testid="checkboxList-checkbox-deleted"
      :disabled="isLoading"
      :label="$t('organization_settings.webhooks_deleted_event')"
      :value="`${entityName}Deleted`"
      v-model="selectedEvents"
      @change="handleChange"
    />
    <v-checkbox
      v-if="shouldDisplayEvent('challengeRevLinked')"
      class="mt-n4 mb-0"
      data-testid="checkboxList-checkbox-challengeRevLinked"
      :disabled="isLoading"
      :label="$t('organization_settings.webhooks_challenge_rev_linked_event')"
      :value="`${entityName}RevLinked`"
      v-model="selectedEvents"
      @change="handleChange"
    />
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'CheckboxList',

  props: {
    entityName: {
      type: String,
    },
    isLoading: {
      type: Boolean,
    },
    initialSelectedEvents: {
      type: Array,
    },
    allowedEvents: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedEvents: this.initialSelectedEvents,
    }
  },

  computed: {
    entityTranslation() {
      switch (this.entityName) {
        case 'rev':
          return this.$t('common.rev_other')
        case 'challenge':
          return this.$t('common.challenge_other')
        case 'account':
          return this.$t('common.account_other')
        case 'routine':
          return this.$t('routines.routine_other')
        case 'finding':
          return this.$t('routines.finding_other')
        case 'organization':
          return this.$t('common.organization_other')
        case 'task':
          return this.$t('common.task_other')
        default:
          return ''
      }
    },
  },

  methods: {
    handleChange() {
      this.$emit('change', this.selectedEvents)
    },
    allowDisplay(eventType) {
      return (
        _.isEmpty(this.allowedEvents) ||
        this.allowedEvents.some(item => item === eventType)
      )
    },
    shouldDisplayEvent(eventType) {
      if (eventType === 'challengeRevLinked') {
        return this.entityName === 'challenge' && this.allowDisplay(eventType)
      }

      return this.allowDisplay(eventType)
    },
  },
  watch: {
    initialSelectedEvents(newVal) {
      this.selectedEvents = newVal
    },
  },
}
</script>
